<template>
  <div class="mobile-nav">
    <!-- 汉堡菜单按钮 -->
    <div class="hamburger" @click="toggleMenu" :class="{ active: isMenuOpen }">
      <span></span>
      <span></span>
      <span></span>
    </div>
    
    <!-- Logo -->
    <div class="mobile-logo">
      <img src="@/assets/pig.png" alt="logo" @click="goHome"/>
    </div>
    
    <!-- 菜单遮罩层 -->
    <div class="menu-overlay" v-show="isMenuOpen" @click="toggleMenu"></div>
    
    <!-- 侧边菜单 -->
    <transition name="slide">
      <div class="side-menu" v-show="isMenuOpen">
        <div class="menu-header">
          <img src="@/assets/pig.png" alt="logo"/>
          <span class="close-btn" @click="toggleMenu">&times;</span>
        </div>
        <ul class="menu-list">
          <li 
            v-for="(item, index) in menuItems" 
            :key="index"
            @click="handleClick(item)"
            :class="{ active: currentRoute === item.path }"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MobileNav',
  props: {
    menuItems: {
      type: Array,
      default: () => [
        { name: '公司简介', path: '/introduction/index' },
        { name: '形象大片', path: '/corporateImage/index' },
        { name: '品牌资讯', path: '/brandInformation/index' },
        { name: '加盟信息', path: '/franchise/index' },
        { name: '体验官计划', path: '/ambassador/index' }        
      ]
    }
  },
  data() {
    return {
      isMenuOpen: false
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
      
      // 触发自定义事件，控制首页视频显示/隐藏
      window.dispatchEvent(new CustomEvent('mobile-menu-toggle', { 
        detail: { isOpen: this.isMenuOpen } 
      }));
    },
    goHome() {
      this.$router.push('/');
      this.isMenuOpen = false;
    },
    handleClick(item) {
      this.$router.push(item.path);
      this.isMenuOpen = false;
    }
  },
  watch: {
    $route() {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-nav {
  display: none;
  
  @media screen and (max-width: 768px) {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    background-color: rgba(251, 251, 251, 0.95) !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 99999 !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  cursor: pointer;
  z-index: 100000 !important;
  
  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #333;
    transition: all 0.3s ease;
  }
  
  &.active {
    span:nth-child(1) {
      transform: translateY(8px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translateY(-8px) rotate(-45deg);
    }
  }
}

.mobile-logo {
  z-index: 99998 !important;
  img {
    width: 80px;
    height: auto;
    cursor: pointer;
  }
}

.menu-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 2147483646 !important;
}

.side-menu {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 85% !important;
  max-width: 320px;
  height: 100% !important;
  background-color: #fff !important;
  z-index: 2147483647 !important;
  overflow-y: auto;
  
  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background-color: #f5f5f5;
    
    img {
      width: 100px;
      height: auto;
    }
    
    .close-btn {
      font-size: 28px;
      cursor: pointer;
      color: #666;
      
      &:hover {
        color: #333;
      }
    }
  }
  
  .menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 18px 20px;
      font-size: 16px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: background-color 0.3s;
      line-height: 1.4;
      
      &:hover, &.active {
        background-color: #f0f0f0;
        color: #000;
      }
      
      &.active {
        font-weight: bold;
        border-left: 3px solid #000;
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
